import { render, staticRenderFns } from "./MainContentArea.vue?vue&type=template&id=cc1562e2&scoped=true"
import script from "./MainContentArea.vue?vue&type=script&lang=js"
export * from "./MainContentArea.vue?vue&type=script&lang=js"
import style0 from "./MainContentArea.vue?vue&type=style&index=0&id=cc1562e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1562e2",
  null
  
)

export default component.exports